import ActInstallSnippet from 'content/snippets/main/act-install';
import ImportSnippet from 'content/snippets/main/mdx-import';
import ActPostsSnippet from 'content/snippets/main/act-posts';
import ActSnippetsSnippet from 'content/snippets/main/act-snippets';
import GatsbyUsageSnippet from 'content/snippets/main/gatsby-usage';
import ActGithubSnippet from 'content/snippets/main/act-github';
import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default {
  ActInstallSnippet,
  ImportSnippet,
  ActPostsSnippet,
  ActSnippetsSnippet,
  GatsbyUsageSnippet,
  ActGithubSnippet,
  React,
  MDXTag
};